
document.addEventListener('click', (e) => {
  const a = e.target.closest('a[href*="#"]');
  if (!a) return;
  const href = a.getAttribute('href');
  if (!href) return;
  if (href.startsWith('http') || href.startsWith('/')) return;
  const hashIndex = href.indexOf('#');
  if (hashIndex === -1) return;
  const id = href.slice(hashIndex + 1);
  const el = document.getElementById(id);
  if (el) {
    e.preventDefault();
    el.scrollIntoView({behavior:'smooth', block:'start'});
    history.replaceState({}, '', '#' + id);
  }
});

window.tgIntake = function(form) {
  const fd = new FormData(form);
  const services = (fd.getAll('services')||[]).join(', ');
  const body = `New Intake Request\n\nContact: ${fd.get('contact')||''}\nEmail: ${fd.get('email')||''}\nPhone: ${fd.get('phone')||''}\nRecipient: ${fd.get('recipient')||''}\nAge: ${fd.get('age')||''}\nCity: ${fd.get('city')||''}\nAddress: ${fd.get('address')||''}\nServices: ${services}\nSchedule: ${fd.get('schedule')||''}\nHours: ${fd.get('hours')||''}\nNotes: ${fd.get('notes')||''}`;
  const url = `mailto:wecare@thrivinggoals.com?subject=${encodeURIComponent('New Intake Request')}&body=${encodeURIComponent(body)}`;
  window.location.href = url;
};

window.tgContact = function(form) {
  const fd = new FormData(form);
  const body = `New Website Message\n\nFrom: ${fd.get('name')||''}\nEmail: ${fd.get('email')||''}\nPhone: ${fd.get('phone')||''}\nMessage:\n${fd.get('message')||''}`;
  const url = `mailto:wecare@thrivinggoals.com?subject=${encodeURIComponent('New Website Message')}&body=${encodeURIComponent(body)}`;
  window.location.href = url;
};

window.tgApply = function(form, role) {
  const fd = new FormData(form);
  const subject = `Application — ${role}`;
  const body = `New Job Application\n\nRole: ${role}\nName: ${fd.get('name')||''}\nEmail: ${fd.get('email')||''}\nPhone: ${fd.get('phone')||''}\nCity: ${fd.get('city')||''}\nExperience: ${fd.get('experience')||''}`;
  const url = `mailto:wecare@thrivinggoals.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.location.href = url;
};
